<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Awcbly/tc-custom/FC-9781528968966.jpg?1684514595835?1709061199483" alt="This image is the cover for the book My Journey to Love and Back to Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Journey to Love and Back to Life
      </h1>
      <p class="bookDescription body article font2">
        <p>At the age of 50, Cavan found himself alone for the first time in his life. Initially, it was a struggle to fill the emptiness of the evenings and the loneliness of the nights. The days were fine, they were just normal working days and it was as if nothing had changed, but come the evenings, the house was ghostly silent. After a while and with the love and help of those closest to him, Cavan gained confidence to face the evenings and the nights and his thoughts became poetry. His love of music and poetry filled his life and he realised that when put into words, sadness can be beautiful. In this, his first collection of poems, Cavan Collins digs deep into his strong Irish/Welsh ancestry to leave no doubt he has inherited the Celts' beautiful gift of expressing emotions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cavan Collins
      </h2>
      
      <p class="authorDescription body article">Cavan Collins was born in 1952 in North Wales in the village of Gwersyllt on the outskirts of Wrexham. His formative years were spent in Solihull in the West Midlands. He describes his childhood as a wonderful time spent safely with his six brothers. He was educated at Lyndon High School and at the age of 17, he began his career as an accountant which continues to the present day. Cavan has five children and four grandchildren. During the nineties, Cavan entered a new phase in his life moving to the beautiful city of Lichfield in Staffordshire, and it was here that he began to write. His poems remained private for many years until early in 2018 when he asked a friend (who just happened to have the most wonderful Welsh accent) if she would read aloud one of his poems to a small group of people. The positive response caused Cavan to reveal the extent of his extraordinary repertoire and gain the confidence to produce his first book of poems.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2871e998